import type * as Types from '../../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateConnectedUserMutationVariables = Types.Exact<{
  connectedUser: Types.CreateConnectedUserInput;
}>;


export type CreateConnectedUserMutationPage = { readonly __typename?: 'RootMutationType', readonly createConnectedUser: { readonly __typename?: 'AccountsConnectedUser', readonly id: string } };

export type UpdateConnectedUserMutationVariables = Types.Exact<{
  connectedUser: Types.UpdateConnectedUserInput;
}>;


export type UpdateConnectedUserMutationPage = { readonly __typename?: 'RootMutationType', readonly updateConnectedUser: { readonly __typename?: 'AccountsConnectedUser', readonly id: string } };

export type DeleteMutationVariables = Types.Exact<{
  connectedUserId: Types.Scalars['ID']['input'];
}>;


export type DeleteMutationPage = { readonly __typename?: 'RootMutationType', readonly deleteConnectedUser: { readonly __typename?: 'AccountsConnectedUser', readonly id: string } };

export type RenewMutationVariables = Types.Exact<{
  connectedUserId: Types.Scalars['ID']['input'];
}>;


export type RenewMutationPage = { readonly __typename?: 'RootMutationType', readonly renewConnectedUser: { readonly __typename?: 'AccountsConnectedUser', readonly id: string } };


export const CreateConnectedUserDocument = gql`
    mutation CreateConnectedUser($connectedUser: CreateConnectedUserInput!) {
  createConnectedUser(connectedUser: $connectedUser) {
    id
  }
}
    `;
export type CreateConnectedUserMutationFn = Apollo.MutationFunction<CreateConnectedUserMutationPage, CreateConnectedUserMutationVariables>;

/**
 * __useCreateConnectedUserMutation__
 *
 * To run a mutation, you first call `useCreateConnectedUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConnectedUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConnectedUserMutation, { data, loading, error }] = useCreateConnectedUserMutation({
 *   variables: {
 *      connectedUser: // value for 'connectedUser'
 *   },
 * });
 */
export function useCreateConnectedUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateConnectedUserMutationPage, CreateConnectedUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateConnectedUserMutationPage, CreateConnectedUserMutationVariables>(CreateConnectedUserDocument, options);
      }
export type CreateConnectedUserMutationHookResult = ReturnType<typeof useCreateConnectedUserMutation>;
export type CreateConnectedUserMutationResult = Apollo.MutationResult<CreateConnectedUserMutationPage>;
export type CreateConnectedUserMutationOptions = Apollo.BaseMutationOptions<CreateConnectedUserMutationPage, CreateConnectedUserMutationVariables>;
export const UpdateConnectedUserDocument = gql`
    mutation UpdateConnectedUser($connectedUser: UpdateConnectedUserInput!) {
  updateConnectedUser(connectedUser: $connectedUser) {
    id
  }
}
    `;
export type UpdateConnectedUserMutationFn = Apollo.MutationFunction<UpdateConnectedUserMutationPage, UpdateConnectedUserMutationVariables>;

/**
 * __useUpdateConnectedUserMutation__
 *
 * To run a mutation, you first call `useUpdateConnectedUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConnectedUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConnectedUserMutation, { data, loading, error }] = useUpdateConnectedUserMutation({
 *   variables: {
 *      connectedUser: // value for 'connectedUser'
 *   },
 * });
 */
export function useUpdateConnectedUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateConnectedUserMutationPage, UpdateConnectedUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateConnectedUserMutationPage, UpdateConnectedUserMutationVariables>(UpdateConnectedUserDocument, options);
      }
export type UpdateConnectedUserMutationHookResult = ReturnType<typeof useUpdateConnectedUserMutation>;
export type UpdateConnectedUserMutationResult = Apollo.MutationResult<UpdateConnectedUserMutationPage>;
export type UpdateConnectedUserMutationOptions = Apollo.BaseMutationOptions<UpdateConnectedUserMutationPage, UpdateConnectedUserMutationVariables>;
export const DeleteDocument = gql`
    mutation Delete($connectedUserId: ID!) {
  deleteConnectedUser(connectedUserId: $connectedUserId) {
    id
  }
}
    `;
export type DeleteMutationFn = Apollo.MutationFunction<DeleteMutationPage, DeleteMutationVariables>;

/**
 * __useDeleteMutation__
 *
 * To run a mutation, you first call `useDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMutation, { data, loading, error }] = useDeleteMutation({
 *   variables: {
 *      connectedUserId: // value for 'connectedUserId'
 *   },
 * });
 */
export function useDeleteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMutationPage, DeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMutationPage, DeleteMutationVariables>(DeleteDocument, options);
      }
export type DeleteMutationHookResult = ReturnType<typeof useDeleteMutation>;
export type DeleteMutationResult = Apollo.MutationResult<DeleteMutationPage>;
export type DeleteMutationOptions = Apollo.BaseMutationOptions<DeleteMutationPage, DeleteMutationVariables>;
export const RenewDocument = gql`
    mutation Renew($connectedUserId: ID!) {
  renewConnectedUser(connectedUserId: $connectedUserId) {
    id
  }
}
    `;
export type RenewMutationFn = Apollo.MutationFunction<RenewMutationPage, RenewMutationVariables>;

/**
 * __useRenewMutation__
 *
 * To run a mutation, you first call `useRenewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renewMutation, { data, loading, error }] = useRenewMutation({
 *   variables: {
 *      connectedUserId: // value for 'connectedUserId'
 *   },
 * });
 */
export function useRenewMutation(baseOptions?: Apollo.MutationHookOptions<RenewMutationPage, RenewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenewMutationPage, RenewMutationVariables>(RenewDocument, options);
      }
export type RenewMutationHookResult = ReturnType<typeof useRenewMutation>;
export type RenewMutationResult = Apollo.MutationResult<RenewMutationPage>;
export type RenewMutationOptions = Apollo.BaseMutationOptions<RenewMutationPage, RenewMutationVariables>;